import { ref, watch, reactive } from 'vue';

export interface UseUpdateBudgetPromptDialogState {
  athleteTwrn: string | undefined;
  athleteName: string | undefined;
  agreementTwrn: string | undefined;
  /** Payment date (YYYY-MM-DD) after the edit — used to prefill the academic year. */
  paymentDate: string | undefined;
  isOpen: boolean;
}

const DEFAULT_STATE: UseUpdateBudgetPromptDialogState = {
  athleteTwrn: undefined,
  athleteName: undefined,
  agreementTwrn: undefined,
  paymentDate: undefined,
  isOpen: false,
};

const getDefaultState = () => ({ ...DEFAULT_STATE });

const state = reactive<UseUpdateBudgetPromptDialogState>(getDefaultState());

function resetState() {
  Object.assign(state, getDefaultState());
}

const isRendered = ref<boolean>(false);

watch(() => state.isOpen, (isOpen) => {
  if (isOpen && !isRendered.value) isRendered.value = true;
  if (!isOpen) resetState();
});

export function useUpdateBudgetPromptDialog() {
  function open(options: Omit<UseUpdateBudgetPromptDialogState, 'isOpen'>) {
    state.athleteTwrn = options.athleteTwrn;
    state.athleteName = options.athleteName;
    state.agreementTwrn = options.agreementTwrn;
    state.paymentDate = options.paymentDate;
    state.isOpen = true;
  }

  function close() {
    state.isOpen = false;
  }

  return {
    state,
    isRendered,
    resetState,
    open,
    close,
  };
}
